'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.page = exports.bootstrap = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

var _constant = require('./constant');

var _events = require('./events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sectionContent = void 0;
var sections = void 0;
var options = void 0;
var page = void 0;

function bootstrap(ele, Customize) {
  sectionContent = _utils2.default.$$(ele)[0];
  sections = _utils2.default.$$('.fp-section');
  options = (0, _assign2.default)({}, _constant.defaults, Customize);
  initEle();
  (0, _events2.default)(options, page);
}

function initEle() {
  function init() {
    initContent();
    initSlide();
    pageController();
    customize();
  }

  init();

  function initContent() {
    _utils2.default.setCss(sectionContent, {
      'transform': 'translate3d(0,0,0)',
      '-webkit-transform': 'translate3d(0,0,0)',
      'transitionDuration': options.pageSpeed + 'ms',
      '-webkit-transitionDuration': options.pageSpeed + 'ms',
      'display': 'block'
    });

    sectionContent.addEventListener(_utils2.default.transitionEvent, function () {
      page.isScrolling = false;
    }, false);

    for (var i = sections.length - 1; i >= 0; i--) {
      sections[i].style.height = _constant.stepHeight + 'px';
    }

    sections[page.nowPage - 1].classList.add('active');
  }

  function initSlide() {
    var slideWrap = _utils2.default.$$('.fp-slide-wrap');
    var slides = void 0;

    function slideWrapInitHandle() {
      page.isScrolling = false;
    }

    for (var i = slideWrap.length - 1; i >= 0; i--) {
      slides = _utils2.default.$$('.fp-slide', slideWrap[i]);
      for (var j = slides.length - 1; j >= 0; j--) {
        slides[j].style.width = _constant.stepWidth + 'px';
      }
      slideWrap[i].style.width = slides.length * _constant.stepWidth + 'px';
      slideWrap[i].dataset.x = '0';
      slideWrap[i].dataset.index = '1';
      slideWrap[i].addEventListener(_utils2.default.transitionEvent, slideWrapInitHandle, false);
    }
  }

  function pageController() {
    function init() {
      createControllerNode();
      bindEvent();
      initController();
    }

    init();

    function createControllerNode() {
      var controllerWrap = document.createElement('div');
      var controllerText = '';
      controllerWrap.className = 'fp-controller';
      for (var i = sections.length; i--; i > 0) {
        controllerText += "<div class='fp-controller-dotted'></div>";
      }
      controllerWrap.innerHTML = controllerText;
      document.body.appendChild(controllerWrap);
    }

    function bindEvent() {
      var controllers = _utils2.default.$$('.fp-controller-dotted');
      for (var i = controllers.length - 1; i >= 0; i--) {
        controllers[i].addEventListener('click', helper(i + 1), false);
      }
      function helper(i) {
        return function () {
          _utils2.default.addClassToOneEle(controllers, i - 1);
          page.moveTo(i);
        };
      }
    }

    function initController() {
      var controllers = _utils2.default.$$('.fp-controller-dotted');
      controllers[page.nowPage - 1].classList.add('active');
    }
  }

  function customize() {
    var prop = {
      autoScroll: function autoScroll() {
        var timer = null;

        if (options.autoScroll) {
          timer = setInterval(function () {
            page.move.next();
          }, options.autoScroll);
        }
      }
    };

    for (var key in prop) {
      if (prop.hasOwnProperty(key)) {
        prop[key]();
      }
    }
  }
}

exports.page = page = {
  nowPage: 1,
  isScrolling: false,
  translate3dY: 0,

  scrollPage: function scrollPage(pageIndex) {
    var pageDiff = pageIndex - page.nowPage;
    var leaveSection = sections[page.nowPage - 1];
    var nowSection = sections[pageIndex - 1];
    var controllers = _utils2.default.$$('.fp-controller-dotted');
    if (pageIndex >= 1 && pageIndex <= sections.length && !page.isScrolling && pageDiff) {
      if (typeof options.beforeLeave === 'function') {
        options.beforeLeave.call(leaveSection, page.nowPage, pageIndex);
      }

      leaveSection.classList.remove('active');
      _utils2.default.addClassToOneEle(controllers, pageIndex - 1);
      page.translate3dY -= pageDiff * _constant.stepHeight;
      _utils2.default.translate(sectionContent, page.translate3dY, 'y');
      page.isScrolling = true;
      page.nowPage = pageIndex;
      nowSection.classList.add('active');

      if (typeof options.afterLoad === 'function') {
        options.pageSpeed = options.pageSpeed ? 500 : options.pageSpeed;
        setTimeout(function () {
          options.afterLoad.call(nowSection, pageIndex);
        }, options.pageSpeed);
      }
      return true;
    } else {
      return false;
    }
  },

  scrollSlide: function scrollSlide(slideIndex) {
    var slideWrap = _utils2.default.$$('.fp-slide-wrap', sections[page.nowPage - 1])[0];

    if (!slideWrap) {
      console.log('This page has no slide');
      return false;
    }

    var slide = sections[page.nowPage - 1].querySelectorAll('.fp-slide');

    var slideData = slideWrap.dataset;

    var slideNowIndex = parseInt(slideData.index, 10);

    var slideX = slideData.x;

    var slideDiff = slideIndex - slideNowIndex;

    if (slideIndex >= 1 && slideIndex <= slide.length && !page.isScrolling) {
      if (typeof options.beforeSlideLeave === 'function') {
        options.beforeSlideLeave.call(slide[slideNowIndex - 1], page.nowPage, slideNowIndex, slideIndex);
      }

      slide[slideNowIndex - 1].classList.remove('active');
      slideX -= slideDiff * _constant.stepWidth;
      _utils2.default.translate(slideWrap, slideX, 'x');
      page.isScrolling = true;
      slideData.x = slideX;
      slideData.index = slideIndex;
      slide[slideIndex - 1].classList.add('active');

      if (typeof options.afterSlideLoad === 'function') {
        options.pageSpeed = options.pageSpeed ? 500 : options.pageSpeed;
        setTimeout(function () {
          options.afterSlideLoad.call(slide[slideIndex - 1], page.nowPage, slideIndex);
        }, options.pageSpeed);
      }
      return true;
    }
    return false;
  },

  moveTo: function moveTo(pageIndex, slideIndex) {
    if (page.scrollPage(pageIndex)) {
      if (slideIndex) {
        return !!page.scrollSlide(slideIndex);
      }
      return true;
    } else {
      return false;
    }
  },
  move: {
    next: function next(callback) {
      if (page.scrollPage(page.nowPage + 1)) {
        var arg = Array.prototype.slice.call(arguments, 1);

        if (typeof callback === 'function') {
          callback(arg);
        }
        return true;
      } else if (options.loopSection) {
        page.moveTo(1);

        return true;
      } else {
        return false;
      }
    },
    pre: function pre(callback) {
      if (page.scrollPage(page.nowPage - 1)) {
        var arg = Array.prototype.slice.call(arguments, 1);

        if (typeof callback === 'function') {
          callback(arg);
        }
        return true;
      } else {
        return false;
      }
    }
  },
  slide: {
    move: function move(direction) {
      var slideWrap = _utils2.default.$$('.fp-slide-wrap', sections[page.nowPage - 1])[0];
      var slide = sections[page.nowPage - 1].querySelectorAll('.fp-slide');

      var slideNowIndexChange = void 0;

      var slideWillBe = void 0;
      if (direction === 'next') {
        slideNowIndexChange = 1;
        slideWillBe = 1;
      } else {
        slideNowIndexChange = -1;
        slideWillBe = slide.length;
      }
      if (!slideWrap) {
        return false;
      } else {
        var slideData = slideWrap.dataset;
        var slideNowIndex = parseInt(slideData.index, 10);

        if (page.scrollSlide(slideNowIndex + slideNowIndexChange)) {
          slideData.index = slideNowIndex + slideNowIndexChange;
          return true;
        } else if (options.loopSlide && page.scrollSlide(slideWillBe)) {
          slideData.index = slideWillBe;
          return true;
        }
        return false;
      }
    },
    next: function next() {
      this.move('next');
    },
    pre: function pre() {
      this.move('pre');
    }
  }
};

exports.bootstrap = bootstrap;
exports.page = page;




//////////////////
// WEBPACK FOOTER
// ./~/notone/bootstrap.js
// module id = 625
// module chunks = 2